import React from 'react'
import { graphql } from 'gatsby'
import styled from '@emotion/styled'
import { Layout } from 'components'
import * as Boxes from 'components/theme/Boxes'
import { SEO } from 'components/common'
import { ProgressCircle } from 'components/theme/Elements'
import { PageWrapper, Section, RowSmallGap, Column4 } from 'components/theme/Layout'
import { Content } from 'components/theme/Content'
import CircularProgress from '@material-ui/core/CircularProgress';
import AOS from 'aos';
import * as Cta from 'components/common/Cta'

const HeadlineLogo = styled.div`
  display: flex;
  justify-content: center;
  img {
    max-width: 30rem;
  }
`;

export default class extends React.Component {

  componentDidMount() {
    AOS.init({
      duration: 1000,
      once: true
    })
  }

  UNSAFE_componentWillReceiveProps() {
    AOS.refresh();
  }

  render() {
    const { pageContext, location, data } = this.props;
    const backgrounds = {
      'default': data.__commonBackgrounds.edges.filter((item) => item.node.name === 'background_1')[0].node,
      'footer': data.__commonBackgrounds.edges.filter((item) => item.node.name === 'background_2')[0].node
    };

    return (
      <Layout context={pageContext} location={location} menuLayout="light">
        <SEO />
        <PageWrapper>
          <Section className="bottom">
            <HeadlineLogo>
              <img src={data.logo.edges[0].node.publicURL} alt="Andros" />
            </HeadlineLogo>
          </Section>
          <Section className="top">
            <div>
              <Boxes.BoxLargeShadow data-aos="fade-up" style={{ float: 'none', margin: '2rem auto 0' }}>
                <div>
                  <Content className="center">
                    <p>
                      <span style={{ fontSize: '2.1rem' }}>
                        Lancement national des boissons aux fruits sans sucre ajouté en boulangeries-pâtisseries.
                      </span>
                    </p>
                  </Content>
                </div>
              </Boxes.BoxLargeShadow>
            </div>
          </Section>

          <Section className="top">
            <div style={{ position: 'relative' }}>
              <div style={{ position: 'relative' }}>
                <div style={{
                  display: 'flex',
                  justifyContent: 'center',
                  position: 'absolute',
                  width: '100%',
                  top: '-1.2rem'
                }}>
                  <Boxes.Months></Boxes.Months>
                  <Boxes.Months></Boxes.Months>
                  <Boxes.Months></Boxes.Months>
                  <Boxes.Months></Boxes.Months>
                  <Boxes.Months></Boxes.Months>
                  <Boxes.Months></Boxes.Months>
                  <Boxes.Months className="blue">J</Boxes.Months>
                  <Boxes.Months></Boxes.Months>
                  <Boxes.Months></Boxes.Months>
                  <Boxes.Months></Boxes.Months>
                  <Boxes.Months></Boxes.Months>
                  <Boxes.Months></Boxes.Months>
                </div>
              </div>
              <hr />
            </div>
          </Section>

          <Section className="bottom">
            <div>
              <Boxes.BoxDefault style={{ float: 'none', margin: '0 auto', minHeight: 0 }}>
                <Content className="padding s center">
                  <p style={{ fontSize: '2rem' }}>"Message in a Window apporte un support novateur, efficace
                  et très qualitatif, alliant image, sell-in et sell-out. Et une aide significative dans le
                  référencement de notre produit chez Metro"</p>
                  <span className="author"><strong>Virginie</strong>, marketing</span>
                </Content>
              </Boxes.BoxDefault>
            </div>
          </Section>

          <Section className="top main background-default" style={{
            backgroundImage: `url(${backgrounds.default.publicURL})`,
          }}>
            <div>
              <RowSmallGap>
                <Column4 className="smallGap" style={{ paddingLeft: 0 }}>
                  <Boxes.BoxShadow className="columns min-height">
                    <h2><small>Réseau</small></h2>
                    <ProgressCircle>
                      <section>
                        <div>
                          <span>100<small></small></span>
                          <span>boulangeries</span>
                        </div>
                      </section>
                      <CircularProgress variant="static" value={99} />
                    </ProgressCircle>
                    <Content className="padding l">
                      <p>6 grandes villes</p>
                    </Content>
                  </Boxes.BoxShadow>
                </Column4>

                <Column4 className="smallGap" style={{ paddingRight: 0, paddingLeft: 0 }}>
                  <Boxes.BoxShadow className="columns min-height">
                    <h2><small>Audience</small></h2>
                    <ProgressCircle>
                      <section>
                        <div>
                          <span>7,2<small>M</small></span>
                          <span>vues</span>
                        </div>
                      </section>
                      <CircularProgress variant="static" value={99} />
                    </ProgressCircle>
                    <Content className="padding l">
                      <p>515k vues/jour estimées</p>
                    </Content>
                  </Boxes.BoxShadow>
                </Column4>

                <Column4 className="smallGap" style={{ paddingRight: 0 }}>
                  <Boxes.BoxShadow className="columns min-height">
                    <h2><small>Commandes</small></h2>
                    <ProgressCircle>
                      <section>
                        <div>
                          <span>9<small>k</small></span>
                          <span>cols</span>
                        </div>
                      </section>
                      <CircularProgress variant="static" value={99} />
                    </ProgressCircle>
                    <Content className="padding l">
                      <p>90 cols de sell-in en moyenne par PDV</p>
                    </Content>
                  </Boxes.BoxShadow>
                </Column4>
              </RowSmallGap>
            </div>
          </Section>

          <Section>
            <div>
              <Boxes.Box2Columns style={{ padding: 0, maxHeight: '40rem' }}>
                <div>
                  <img style={{
                    margin: '0 auto', display: 'block'
                  }} src={data.placeholder.edges[0].node.publicURL} alt="andros" />
                </div>
              </Boxes.Box2Columns>
              <Boxes.Box2Columns>
                <div>
                  <Content className="full padding s">
                    <p>"J'ai vendu beaucoup de produits, la campagne a attiré les passants et j'en ai été très satisfait !"</p>
                    <span className="author">Maison Vuillard, Bezons</span>
                  </Content>
                  <Content className="full padding s">
                    <p>"Une opération très intéressante, avec un très bon produit,
                    depuis la fin de la campagne j’ai vendu plus d’une vingtaine de produits en plus."</p>
                    <span className="author">La Royale, Nice</span>
                  </Content>
                </div>
              </Boxes.Box2Columns>
            </div>
          </Section>

          <Section className="bottom main" style={{
            padding: '0 0 10rem'
          }}>
            <div>
              <Boxes.BoxLargeShadow style={{ width: '100%' }}>
                <div>
                  <Content>
                    <Cta.ChevronFocus
                      href={`https://www.messageinawindow.com/blog/decouvrez-comment-nous-avons-permis-a-andros-de-simplanter-dans-100-nouvelles-boulangeries/`}
                      title="Lire l'article sur la campagne Andros">
                      Lire l'article sur la campagne Andros
                    </Cta.ChevronFocus>
                  </Content>
                </div>
              </Boxes.BoxLargeShadow>
            </div>
          </Section>
        </PageWrapper>
      </Layout>
    )
  }
}

export const query = graphql`
  query {
    logo: allFile (
      filter: {
        relativePath: {eq: "logos/customer-cases/andros.svg"}
      }
    ) {
      edges {
        node {
          name,
          publicURL
        }
      }
    }
    placeholder: allFile (
      filter: {
        relativePath: {eq: "cas-clients/andros.png"}
      }
    ) {
      edges {
        node {
          name,
          publicURL
        }
      }
    }
    __commonBackgrounds: allFile (
      filter: {
        relativeDirectory: {eq: "backgrounds/common"}
      }
    ) {
      edges {
        node {
          name,
          publicURL
        }
      }
    }
  }
`